import _ from 'lodash'
import styles from './PreserveDaysFields.css'
import SingleLineText from '../../../ReadOnlyComponents/SingleLineText/SingleLineText'
import { InputField, FormError } from '../../../../../Common/Form'

const PreserveDaysFields = props => {
  const {
    setting,
    readOnly,
    product: { years, months, days },
    isNewProposal,
    mustShowFormError
  } = props

  if (readOnly) {
    return (
      <SingleLineText
        content={`${years.input.value} 年 ${months.input.value} 個月 ${days.input.value} 天`}
      />
    )
  }

  const checkFields = [years, months, days]
  const isFieldsHasValue = _.some(checkFields, ({ input }) => !_.isEmpty(input.value))
  const isFieldsInvalid = _.some(checkFields, ({ meta }) => meta.invalid)
  // 決定並排長寬高輸入匡是否顯示紅匡
  const isShowErrorOnActive = isNewProposal
    // 新的提案
    ? mustShowFormError
      // 按過送出 mustShowFormError 會變成 true，所以設定成有 error 直接顯示紅匡
      ? true
      // 未送出前，欄位需要為驗證失敗且其中一列有值才顯示紅匡
      : !(isFieldsInvalid && isFieldsHasValue)
    // 複製的提案
    : false
  const showFormError = (
    // 送出後如果有錯誤直接顯示錯誤
    mustShowFormError ||
    (
      // 如果沒有觸發才需要顯示錯誤，預設直接顯示錯誤
      !isShowErrorOnActive ||
      // 欄位修改過或是被觸發過，預設直接顯示錯誤
      checkFields
        .map(({ meta }) => meta)
        .some(({ touched, dirty }) => touched || dirty)
    )
  )

  const PreserveDaysError = _.get(setting, '_preserveDays.meta.error')

  return (
    <div
      data-role='preserve-days-fields'
      className={styles.PreserveDaysFields}
    >
      <InputField
        key='years'
        hasFormErrorTag={false}
        data-role='product-preserve-years'
        {...years}
        addonAfter='年'
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
      />
      <InputField
        key='months'
        hasFormErrorTag={false}
        data-role='product-preserve-months'
        {...months}
        addonAfter='個月'
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
      />
      <InputField
        key='days'
        hasFormErrorTag={false}
        data-role='product-preserve-days'
        {...days}
        addonAfter='天'
        showErrorOnActive={isShowErrorOnActive}
        mustShowFormError={mustShowFormError}
      />
      <FormError
        key='PreserveDaysError'
        showFormError={showFormError}
        error={PreserveDaysError}
        showErrorOnActive={isNewProposal}
        absolute
      />
    </div>
  )
}

export default PreserveDaysFields
